import DetectionPage from './components/DetectionPage';

const routes = [
  {
    path: '/detection',
    name: 'menu.detection',
    className: 'menu-system-events',
    icon: 'camera',
    customIcon: true,
    loginRequired: true,
    component: DetectionPage,
    weight: 1,
    permission: ['detection'],
    children: [],
  },
];

export default routes;
